import * as Types from '../constants/Types';

export const getListObjectType = (filters) => ({ type: Types.OBJECT_TYPE_LIST_ACTION, filters });
export const setObjectTypes = (objectTypes) => ({ type: Types.OBJECT_TYPE_LIST_SUCCESS, objectTypes});

export const getAllObjectType = (filters) => ({ type: Types.OBJECT_TYPE_ALL_ACTION, filters });
export const setAllObjectType = (objectTypes) => ({ type: Types.OBJECT_TYPE_ALL_SUCCESS, objectTypes});

export const getObjectTypeDetail = (id) => ({ type: Types.OBJECT_TYPE_DETAIL_ACTION, id })
export const setObjectTypeDetail = (objectType) => ({ type: Types.OBJECT_TYPE_DETAIL_SUCCESS, objectType });

export const updateObjectTypeDetail = (objectType) => ({ type: Types.OBJECT_TYPE_DETAIL_UPDATE_ACTION, objectType });
export const createObjectTypeDetail = (objectType) => ({ type: Types.OBJECT_TYPE_DETAIL_CREATE_ACTION, objectType });
export const deleteObjectTypeDetail = (objectType, filters) => ({ type: Types.OBJECT_TYPE_DETAIL_DELETE_ACTION, objectType, filters });

export const createObjectTypeTranslate = (objectType) => ({type: Types.OBJECT_TYPE_CREATE_TRANSLATE_ACTION, objectType});
export const updateObjectTypeTranslate = (objectType) => ({type: Types.OBJECT_TYPE_UPDATE_TRANSLATE_ACTION, objectType});
export const deleteObjectTypeTranslate = (objectType, refreshParams) => ({type: Types.OBJECT_TYPE_DELETE_TRANSLATE_ACTION, objectType, refreshParams});
